<template>
  <Heading
    :level="3"
    class="panel-modal-header border-b border-zinc-200/70 px-6 py-4 text-base font-semibold dark:border-zinc-800"
  >
    <slot />
  </Heading>
</template>

<script>
export default {
  //
}
</script>
